// import React, { useEffect, useState } from 'react';
// import {Link} from 'react-router-dom';
// import Footer from "../../Components/Footer";
// import Header from "../../Components/Header";
// import { blogApis } from "../../Data/axios";
// import Banner from '../../Components/Banner';
// import config from "../../Data/AuthUser";

// const BlogSection = () => {
//     const [activeSection, setActiveSection] = useState('Blogs');
//     const [featuredPosts, setFeaturedPosts] = useState([]);
//     const [recentPosts, setRecentPosts] = useState([]);
//     const [blogs, setBlogs] = useState([]);
//     const [news, setNews] = useState([]);
//     const [resources, setResources] = useState([]);
//     const [tutorials, setTutorials] = useState([]);
//     const [posts, setPosts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         fetchBlogsData(1);
//     }, []);


//     const fetchBlogsData = async (type) => {
//         try {
//             setLoading(true);
//             const resblogs = await blogApis.getAllByType(type);
//             setPosts(resblogs?.data || []);
//         } catch (err) {
//             setError(err.message || "Failed to fetch blogs");
//         } finally {
//             setLoading(false);
//         }
//     };
//     const getEmbedUrl = (url) => {
//         const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
//         return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
//       };

// const renderPosts = () => {
//     const leftColumn = posts.filter((_, index) => index % 2 === 0);
//     const rightColumn = posts.filter((_, index) => index % 2 !== 0);

//     return (
//         <div className="flex flex-col md:flex-row gap-8">
//             <div className="w-full md:w-1/2 space-y-6">
//                 {leftColumn.map((post, index) => (
//                     <Link to={`/blogs/${post.id}`} key={index}>
//                         <div className="bg-[#F8F7FF] rounded-lg overflow-hidden shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-xl">
//                             <div className="md:flex">
//                                 <div className="md:flex-shrink-0">
//                                     {post.youtube ? (
//                                         <iframe
//                                             width="100%"
//                                             height="315"
//                                             src={getEmbedUrl(post.youtube)}
//                                             title={post.title}
//                                             frameBorder="0"
//                                             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                             allowFullScreen
//                                         ></iframe>
//                                     ) : post.image ? (
//                                         <img
//                                             src={`${config.apiImageUrl}${post.image}`}
//                                             alt={`${post.title} thumbnail`}
//                                             className="h-48 w-full object-cover md:w-48"
//                                         />
//                                     ) : (
//                                         <div className="h-48 w-full md:w-48 bg-gray-200 flex items-center justify-center text-gray-500">
//                                             No Image
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div className="p-4">
//                                     <h3 className="text-lg font-semibold mb-2">{post.title}</h3>
//                                     <p className="text-gray-600 text-sm mb-2">{post.description}</p>
//                                     <div className="flex justify-between items-center text-xs text-gray-500">
//                                         {/* <span>{post.created_by}</span> */}
//                                         <span>{new Date(post.created_at).toLocaleDateString()}</span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </Link>
//                 ))}
//             </div>
//             <div className="w-full md:w-1/2 space-y-6">
//                 {rightColumn.map((post, index) => (
//                     <Link to={`/blogs/${post.id}`} key={index}>
//                         <div className="bg-[#F8F7FF] rounded-lg overflow-hidden shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-xl">
//                             <div className="md:flex">
//                                 <div className="md:flex-shrink-0">
//                                     {post.youtube ? (
//                                         <iframe
//                                             width="100%"
//                                             height="315"
//                                             src={getEmbedUrl(post.youtube)}
//                                             title={post.title}
//                                             frameBorder="0"
//                                             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                             allowFullScreen
//                                         ></iframe>
//                                     ) : post.image ? (
//                                         <img
//                                             src={`${config.apiImageUrl}${post.image}`}
//                                             alt={`${post.title} thumbnail`}
//                                             className="h-48 w-full object-cover md:w-48"
//                                         />
//                                     ) : (
//                                         <div className="h-48 w-full md:w-48 bg-gray-200 flex items-center justify-center text-gray-500">
//                                             No Image
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div className="p-4">
//                                     <h3 className="text-lg font-semibold mb-2">{post.title}</h3>
//                                     <p className="text-gray-600 text-sm mb-2">{post.description}</p>
//                                     <div className="flex justify-between items-center text-xs text-gray-500">
//                                         {/* <span>{post.created_by}</span> */}
//                                         <span>{new Date(post.created_at).toLocaleDateString()}</span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </Link>
//                 ))}
//             </div>
//         </div>
//     );
// };

// return (
//     <div className="container mx-auto px-4 py-8 max-w-7xl font-ubuntu">
//         <div className="flex justify-center mb-8">
//             {['Blogs', 'News', 'Resources', 'Tutorials'].map((category, index) => {
//                 const type = index + 1; // Map categories to types (1 for Blogs, 2 for News, etc.)
//                 return (
//                     <button
//                         key={category}
//                         className={`mx-2 px-4 py-2 rounded-lg ${activeSection === category ? 'bg-csyellow text-white' : 'bg-gray-200 text-gray-700'}`}
//                         onClick={() => {
//                             setActiveSection(category);
//                             fetchBlogsData(type); // Fetch data for the selected category
//                         }}
//                     >
//                         {category}
//                     </button>
//                 );
//             })}
//         </div>
//         {loading ? (
//             <p>Loading...</p>
//         ) : error ? (
//             <p className="text-red-500">{error}</p>
//         ) : (
//             renderPosts()
//         )}
//     </div>
// );
// };
// const Blogs = () => {

//   return (
//     <div>
//       <Header />
//       <div className='bg-topo-bg '>
//         <BlogSection />
//       </div>
//       <Footer />
//     </div>
//   );

// };

// export default Blogs;


import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { blogApis } from "../../Data/axios";
import Banner from '../../Components/Banner';
import config from "../../Data/AuthUser";

const BlogSection = () => {
    const [activeSection, setActiveSection] = useState('Blogs');
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchBlogsData(1);
    }, []);

    const fetchBlogsData = async (type) => {
        try {
            setLoading(true);
            const resblogs = await blogApis.getAllByType(type);
            const activePosts = resblogs?.data?.filter(post => post.status === 1) || [];
            setPosts(activePosts);
        } catch (err) {
            setError(err.message || "Failed to fetch blogs");
        } finally {
            setLoading(false);
        }
    };

    const getEmbedUrl = (url) => {
        const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
    };

    const getCategoryColor = (category) => {
        return 'bg-csyellow';
    };

    const renderPostCard = (post, index) => (
        <Link to={`/blogs/${post.id}`} key={index}>
            <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 h-full flex flex-col">
                <div className="relative">
                    {post.youtube ? (
                        <iframe
                            width="100%"
                            height="200"
                            src={getEmbedUrl(post.youtube)}
                            title={post.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="w-full"
                        ></iframe>
                    ) : post.image ? (
                        <img
                            src={`${config.apiImageUrl}${post.image}`}
                            alt={`${post.title} thumbnail`}
                            className="w-full h-48 object-cover"
                        />
                    ) : (
                        <div className="w-full h-48 bg-gray-100 flex items-center justify-center">
                            <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                            </svg>
                        </div>
                    )}
                    <div className="absolute top-4 right-4 bg-white px-2 py-1 rounded-full text-xs font-medium text-gray-700 shadow">
                        {(() => {
                          const d = new Date(post.created_at);
                          const dd = String(d.getDate()).padStart(2, "0");
                          const mm = String(d.getMonth() + 1).padStart(2, "0");
                          return `${dd}-${mm}-${d.getFullYear()}`;
                        })()}
                    </div>
                </div>
                <div className="p-5 flex flex-col flex-grow">
                    <h3 className="text-xl font-bold mb-3 text-gray-800 line-clamp-2">{post.title}</h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">{post.description}</p>
                    <div className="mt-auto">
                    {post.type === 2 && post.link && (
    <div className="mt-4">
        <a
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-csyellow hover:bg-yellow-500 text-white py-2 px-4 rounded-md transition-colors duration-300 inline-flex items-center"
            onClick={(e) => e.stopPropagation()}
        >
            Learn More
            <svg
                className="w-4 h-4 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
            </svg>
        </a>
    </div>
)}
                    </div>
                </div>
            </div>
        </Link>
    );

    const renderPosts = () => {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {posts.map((post, index) => renderPostCard(post, index))}
            </div>
        );
    };

    return (
        <div className="container mx-auto px-4 py-8 sm:py-12 max-w-7xl font-ubuntu">
            <div className="text-center mb-8 sm:mb-12">
                <h2 className="text-3xl sm:text-4xl md:text-5xl text-csyellow font-bold mb-2">Latest {activeSection}</h2>
                <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">Stay updated with our latest articles, news, and resources.</p>
            </div>
            
            <div className="flex justify-center mb-6 sm:mb-10">
                <div className="inline-flex bg-gray-100 p-1 rounded-xl shadow-sm">
                    {['Blogs', 'News', 'Resources', 'Tutorials'].map((category, index) => {
                        const type = index + 1;
                        return (
                            <button
                                key={category}
                                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 text-sm sm:text-base ${
                                    activeSection === category 
                                    ? `${getCategoryColor(category)} text-white shadow-md` 
                                    : 'bg-transparent text-gray-700 hover:bg-gray-200'
                                }`}
                                onClick={() => {
                                    setActiveSection(category);
                                    fetchBlogsData(type);
                                }}
                            >
                                {category}
                            </button>
                        );
                    })}
                </div>
            </div>
            
            {loading ? (
                <div className="flex justify-center items-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-csyellow"></div>
                </div>
            ) : error ? (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-center">
                    <p>{error}</p>
                </div>
            ) : posts.length === 0 ? (
                <div className="text-center py-20">
                    <div className="text-gray-400 mb-4">
                        <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                        </svg>
                    </div>
                    <h3 className="text-lg sm:text-xl font-medium text-gray-600">No {activeSection.toLowerCase()} found</h3>
                    <p className="text-sm sm:text-base text-gray-500 mt-2">Check back later for new content</p>
                </div>
            ) : (
                renderPosts()
            )}
        </div>
    );
};

const Blogs = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
            <div className="bg-topo-bg pb-20">
                <BlogSection />
            </div>
            <Footer />
        </div>
    );
};

export default Blogs;